angular.module('admin')
  .controller('AgentClientListCtrl', ['$scope', '$state', '$rootScope', 'HomeService', 'AgentService', 'UtilService', 'APP_CONFIG', '$window',
    function($scope, $state, $rootScope, HomeService, AgentService, utils, APP_CONFIG, $window){

    $scope.agentId =  $state.params.id;
    $scope.searchType = 'homeownerName';
    $scope.clientsPerPage = parseInt(APP_CONFIG.CLIENTS_PER_PAGE, 10);
    $scope.homeCount = 0;

    $scope.allClientsSort = $window.localStorage.getItem('hb-client-sort') || 'Name';
    $scope.allClientsOrder = $window.localStorage.getItem('hb-client-order') || 'DESC';

    $scope.getListType = function(){
      if($state.is('agent.clients') || $state.is('agent.clients.page'))
        return 'search';

      if($state.is('agent.clients.needsCMA'))
        return 'needsCMA';

      if($state.is('agent.clients.emailIssues'))
        return 'emailIssues';

      if($state.is('agent.clients.invited'))
        return 'invited';

      if($state.is('agent.clients.sharedClients'))
        return 'sharedClients';
    };

    $scope.getHomeCount = function(){
      AgentService
        .countHomes($scope.agentId)
        .then((data) => {
          $scope.homeCount = data.count;
        });
    };

    $scope.getHomeProcessingCount = function(){
      AgentService
        .countHomes($scope.agentId, {
          processed: false,
        })
        .then((data) => {
          $scope.homeProcessingCount = data.count;
        });
    };

    $scope.clearSearch = function(){
      $scope.searchQuery = '';
    };

    $scope.getNeedsCMACount = function(){
      AgentService
        .countHomes($scope.agentId, {
          'metadata.needsCMA': true,
        })
        .then((data) => {
          $scope.needsCMACount = data.count;
        });
    };

    $scope.getAgent = function(){
      return AgentService.getOne($scope.agentId)
        .then((agent) => {
          $scope.agent = agent;
        })
        .catch((err) => {
          $scope.error = 'There was an error loading agent profile: ' + err;
        });
    };

    $scope.sendAll = function(){
      if(!confirm('Send an email and text to ' + $scope.unsentCount + ' clients?'))
        return false;

      $scope.sendingAll = true;
      $scope.error = '';

      AgentService.sendAll($scope.agentId)
        .then(function(data){
          $scope.sendingAll = false;
        })
        .catch(function(err){
          $scope.sendingAll = false;
          $scope.error = err;
          utils.trackException('Send All Digests', err);
        });
    };

    $scope.isView = function(view){
      return $state.is(view);
    };

    $scope.displayPagination = function(){
      if($scope.homeCount < $scope.clientsPerPage)
        return false;

      // TODO: we won't need these when we have search and needsCMA counts
      // The api needs to return the total number of results.
      if($scope.searchQuery) return false;
      if(!$scope.isView('agent.clients') && !$scope.isView('agent.clients.page')) return false;

      return true;
    };

    $scope.isUserList = function(){
      let userListTypes = ['emailIssues', 'invited'];
      if(userListTypes.includes($scope.getListType()))
        return true;

      return false;
    };

    var pageWatch = $rootScope.$on('$stateChangeStart', setCurrentPage);

    $scope.$on('$destroy', pageWatch); // removes from $rootScope

    function setCurrentPage(evt, toState, toParams){
      $scope.currentPage = toParams.page && toParams.page > 0 ? toParams.page : 1;
    };

    function setSort(sort){
      $scope.allClientsSort = sort;
      $window.localStorage.setItem('hb-client-sort', $scope.allClientsSort);
    }

    function setSortOrder(isNewSort){
      if(isNewSort || $scope.allClientsOrder === 'ASC')
        $scope.allClientsOrder = 'DESC';
      else
        $scope.allClientsOrder = 'ASC';

      $window.localStorage.setItem('hb-client-order', $scope.allClientsOrder);
    }

    $scope.updateSort = (sort) => {
      const isNewSort = sort === $scope.allClientsSort ? false : true;
      setSort(sort);
      setSortOrder(isNewSort);
      setCurrentPage(null, null, {page: 1});
      $state.go('agent.clients');
    };

    $scope.goToPage = function(text, page){
      $state.go('agent.clients.page', {page:page});
      window.scrollTo(0,0);
    }

    setCurrentPage(null, null, $state.params);
    $scope.getAgent();
    $scope.getHomeCount();
    $scope.getHomeProcessingCount();
    $scope.getNeedsCMACount();
}]);
